import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { UiLegacy } from "@silvertours/front-legacy-shared";
import { Badge, InfoIcon } from "./TooltipBadge.styles";
var TooltipBadge = function(param) {
    var badgeText = param.badgeText, tooltipTitle = param.tooltipTitle, tooltipText = param.tooltipText, onHover = param.onHover;
    return /*#__PURE__*/ _jsxs(Badge, {
        children: [
            badgeText,
            /*#__PURE__*/ _jsx(UiLegacy.Tooltip, {
                content: /*#__PURE__*/ _jsx(UiLegacy.Markup, {
                    content: tooltipText
                }),
                title: tooltipTitle,
                width: "wide",
                trigger: /*#__PURE__*/ _jsx(InfoIcon, {
                    onMouseEnter: onHover
                })
            })
        ]
    });
};
export { TooltipBadge };
